<template>
    <div>
        <!-- 过滤条件 -->
        <div :class="preCls + 'filter'" style="margin-bottom: 20px">
            <Select
                style="width: 100px; margin-right: 15px"
                v-model="filter.trackStatus"
                placeholder="跟进情况"
                @on-change="search"
                clearable
            >
                <Option
                    v-for="item in trackStatusList"
                    :value="item.text"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <Select
                style="width: 100px; margin-right: 15px"
                v-model="filter.cusSource"
                placeholder="客户来源"
                @on-change="search"
                clearable
            >
                <Option
                    v-for="item in cusSourceList"
                    :value="item.text"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <Select
                style="width: 100px; margin-right: 20px"
                v-model="filter.cusStatus"
                placeholder="客户状态"
                clearable
            >
                <Option
                    v-for="item in cusStatusList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            ></filter-date-range>
        </div>
        <!-- 列表工具栏 -->
        <table-tool-bar style="margin-top: 16px">
            <template slot="left">
                <table-searcher
                    v-model="filter.cusName"
                    placeholder="请输入客户姓名,手机号或单位名称"
                    style="margin-left: 10px"
                    @search="search"
                    >搜索</table-searcher
                >
            </template>
            <Button
                v-if="$can('add')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onClickAdd"
                >新增客户</Button
            >
            <Button
                v-if="$can('exportExcel')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                @click="onClickExport"
                >导出Excel</Button
            >
        </table-tool-bar>
        <!-- 列表-->
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template v-slot:action="{ row }">
                <Button
                    v-if="$can('view')"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickView(row)"
                    >详情</Button
                >
                <Button
                    v-if="$can('update')"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickUpdate(row)"
                    >修改</Button
                >
                <Button
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickTack(row)"
                    >回访记录</Button
                >
            </template>
            <template v-slot:cusStatusText="{ row }">
                <tag-status
                    :text="row.cusStatusText"
                    :color="row.cusStatusColor"
                    :background="row.cusStatusBgc"
                    circle
                />
            </template>
            <template v-slot:cusSource="{ row }">
                {{ dict.cusSource.val(row.cusSource) }}
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            transfer
            :total.sync="page.totalCount"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.page"
            @change="fetch"
        ></table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showCustomer"
            :title="actionTitle + '客户'"
            :width="800"
            :height="500"
            :maskClosable="false"
            @close-by-confirm="fetch"
        >
            <c-info-yxkh-form
                v-if="modal.showCustomer"
                :id="curId"
                :cusName="curCusName"
                :cusMobile="cusMobile"
                :form-mode="formMode"
            />
        </smart-modal>

        <smart-modal
            v-model="modal.showHfjlList"
            :title="curId ? '回访记录' : '回访记录'"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="fetch"
            @close-by-cancel="fetch"
        >
            <c-info-hfjl-list
                v-if="modal.showHfjlList"
                :id="curId"
                :cusName="curCusName"
                :cusMobile="cusMobile"
            ></c-info-hfjl-list>
        </smart-modal>
    </div>
</template>
<script>
import { cInfoList } from '@/api/customer'
import CInfoYxkhForm from './c-info-yxkh-form'
import CInfoHfjlList from './c-info-hfjl-list'
import { mapCache } from '_g/vux-data-cache'
import { pipeCell } from '_c/grid/renderCell'
import TagStatus from '_vc/tag-status'
import { ymdL } from '_u/helper'
import dayjs from 'dayjs'
import mList from '_v/common/m-list'

export default {
    name: 'CustomerList',
    mixins: [mList],
    components: {
        CInfoYxkhForm,
        CInfoHfjlList,
        TagStatus,
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            page: {
                totalCount: 0,
                list: [],
            },
            curId: '',
            curCusName: '',
            cusMobile: '',
            modal: {
                showCustomer: false,
                showHfjlList: false,
            },
            dict: {
                cusStatus: this.$dict.NULL,
                trackStatus: this.$dict.NULL,
                cusSource: this.$dict.NULL,
            },
        }
    },

    computed: {
        ...mapCache({
            filter: 'yxkhFilter', //将要缓存的改成本地命名
        }),
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 80,
                },
                {
                    key: 'createTime',
                    title: '创建时间',
                    align: 'center',
                    minWidth: 150,
                    tooltip: true,
                    render: pipeCell('ymdL'), //使用全局filter转化成格式化的数据
                },
                {
                    key: 'cusName',
                    title: '客户姓名',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'cusMobile',
                    title: '客户手机号',
                    align: 'center',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'comName',
                    title: '单位名称',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'cusStatusText',
                    title: '客户状态',
                    align: 'center',
                    minWidth: 160,
                    tooltip: true,
                    slot: 'cusStatusText',
                },
                {
                    key: 'cusSource',
                    title: '客户来源',
                    align: 'center',
                    minWidth: 120,
                    tooltip: true,
                    slot: 'cusSource',
                },
                {
                    key: 'trackStatus',
                    title: '跟进情况',
                    align: 'center',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'content',
                    title: '跟进内容',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 200,
                    fixed: 'right',
                    slot: 'action',
                },
            ]
        },

        trackStatusList() {
            return this.dict.trackStatus.toList() // 跟进情况
        },
        cusSourceList() {
            return this.dict.cusSource.toList() //客户来源列表
        },
        cusStatusList() {
            let dictCS = this.dict.cusStatus.toList().filter((item) => {
                return item.id < 3
            })
            return dictCS
            // 客户状态
        },
    },

    created() {
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    methods: {
        search() {
            this.filter.page = 1
            this.fetch()
        },

        fetch() {
            this.loading = true
            Promise.all([
                cInfoList(this.filter),
                this.$dict.get([
                    'cus_status',
                    'track_status',
                    'cus_source',
                    'action_type',
                ]),
            ])
                .then((args) => {
                    var [view, group] = args

                    Object.assign(this.dict, group)

                    const cusStatusDict = this.dict.cusStatus
                    view.data.page.list.forEach((v) => {
                        const cusStatus = cusStatusDict.get(v.cusStatus)
                        v.cusStatusText = cusStatus.text
                        v.cusStatusColor = JSON.parse(cusStatus.remark).color
                        v.cusStatusBgc = JSON.parse(cusStatus.remark).background
                    })
                    this.page.list = view.data.page.list
                    this.page.totalCount = parseInt(view.data.page.totalCount)
                })
                .finally(() => (this.loading = false))
        },

        // 导出数据处理
        onClickExport() {
            this.$refs.mt.exportToExcel({
                filename: '数据表',
                index: true,
                rows: this.page.list.map((data, index) => {
                    let pageData = Object.assign({}, data)
                    pageData.createTime = ymdL(pageData.createTime)
                    pageData.cusStatus = this.dict.cusStatus.val(data.cusStatus)
                    return pageData
                }),
            })
        },

        onClickAdd() {
            this.formMode = this.FORM_MODE.add
            this.curId = ''
            this.modal.showCustomer = true
        },

        rowClickView(row) {
            this.formMode = this.FORM_MODE.view
            this.curId = row.id
            this.modal.showCustomer = true
        },

        rowClickUpdate(row) {
            this.formMode = this.FORM_MODE.update
            this.curId = row.id
            this.modal.showCustomer = true
        },

        rowClickTack(row) {
            this.curId = row.id
            this.curCusName = row.cusName
            this.cusMobile = row.cusMobile
            this.modal.showHfjlList = true
        },

        parseTime(time) {
            return dayjs(time).format('YYYY-MM-DD')
        },
    },
    watch: {
        'filter.cusStatus': function (val) {
            if (!val) {
                this.filter.cusStatus = '1,2'
                this.search()
            } else {
                this.search()
            }
        },
    },
}
</script>
<style lang="less" scoped></style>
